import React from 'react';
import { WebsiteDesignProps } from './types';
import { Layers, Plus, Share2 } from 'lucide-react';
import { Button } from "@/components/ui/button";

const MaterialDepth: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Quantum Material School";

    return (
        <div className="bg-[#fafafa] min-h-screen font-sans text-gray-800 selection:bg-purple-200">
             <header className="bg-white shadow-md sticky top-0 z-50">
                 <div className="container mx-auto px-4 h-16 flex items-center justify-between">
                     <div className="flex items-center gap-4">
                         <div className="p-2 bg-purple-600 text-white rounded shadow-sm">
                             <Layers size={24} />
                         </div>
                         <span className="text-xl font-medium tracking-tight text-gray-700">{schoolName}</span>
                     </div>
                     <div className="flex gap-2">
                         <Button variant="ghost" className="text-purple-600 font-medium">Login</Button>
                         <Button className="bg-purple-600 hover:bg-purple-700 text-white shadow-lg shadow-purple-200 transition-all hover:shadow-xl">Get Started</Button>
                     </div>
                 </div>
             </header>

             <main className="container mx-auto px-4 py-16">
                 <div className="flex flex-col md:flex-row gap-12 items-center mb-24">
                     <div className="md:w-1/2">
                         <h1 className="text-5xl md:text-6xl font-normal text-gray-800 mb-6 leading-tight">
                             Learning with <br/> <span className="text-purple-600 font-bold">Dimension.</span>
                         </h1>
                         <p className="text-xl text-gray-500 mb-8 leading-relaxed">
                             A layered approach to education. We build knowledge block by block, creating a solid structure for future innovation.
                         </p>
                         <div className="flex gap-4">
                             <Button className="h-12 px-8 bg-white text-gray-700 border border-gray-200 shadow-sm hover:shadow-md transition-all font-medium rounded-lg">
                                 View Courses
                             </Button>
                             <Button className="h-12 px-8 bg-purple-600 text-white shadow-lg shadow-purple-200 hover:shadow-xl hover:-translate-y-0.5 transition-all font-medium rounded-lg">
                                 Join Now
                             </Button>
                         </div>
                     </div>
                     <div className="md:w-1/2 relative h-96 w-full">
                          {/* Floating Cards */}
                          <div className="absolute top-0 right-0 w-64 h-80 bg-white rounded-xl shadow-2xl z-10 p-6 transform rotate-3 hover:rotate-0 transition-transform duration-500 cursor-pointer">
                              <div className="w-full h-40 bg-pink-100 rounded-lg mb-4"></div>
                              <div className="h-4 w-3/4 bg-gray-100 rounded mb-2"></div>
                              <div className="h-4 w-1/2 bg-gray-100 rounded"></div>
                          </div>
                          <div className="absolute top-10 right-20 w-64 h-80 bg-purple-600 rounded-xl shadow-2xl z-0 transform -rotate-6"></div>
                          
                          <div className="absolute bottom-0 left-10 w-16 h-16 bg-yellow-400 rounded-full shadow-lg flex items-center justify-center text-white z-20 animate-bounce">
                              <Plus size={32} />
                          </div>
                     </div>
                 </div>

                 <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                     {[
                         { color: "bg-blue-500", title: "Modern Tools" },
                         { color: "bg-green-500", title: "Collaborative" },
                         { color: "bg-red-500", title: "Fast Paced" }
                     ].map((item, i) => (
                         <div key={i} className="bg-white p-0 rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 overflow-hidden group cursor-pointer">
                             <div className={`h-2 ${item.color}`}></div>
                             <div className="p-8">
                                 <h3 className="text-2xl font-bold mb-2 text-gray-800">{item.title}</h3>
                                 <p className="text-gray-500">
                                     Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt.
                                 </p>
                             </div>
                             <div className="bg-gray-50 p-4 flex justify-between items-center text-sm font-medium text-gray-500 group-hover:text-purple-600 transition-colors">
                                 Learn More <Share2 size={16} />
                             </div>
                         </div>
                     ))}
                 </div>
             </main>
        </div>
    );
};

export default MaterialDepth;
